export default {
  high: 'Label-GU-Primary',
  medium: 'Interface-Eighth',
  low: 'Label-Secondary',
}
